export const API_URL_AUTH = "https://srvauth.psisim.net";
export const API_URL_PAY = "https://srvpay1.psisim.net";

export const API_REFRESH = "https://srvauth.psisim.net/mopsimapp/refreshtokendevice";
export const API_OUTLET = "https://srvauth.psisim.net/mopsimapp/all-outlet-group";
export const API_DATA = "https://srvpay1.psisim.net/mopsimapp/alltotal-sim";

export const API_PAYMENT = "https://srvpay1.psisim.net/mopsimapp/payment";
export const API_PAYMENT_DOWNLOAD = "https://srvpay1.psisim.net/mopsimapp/payment/download";
export const API_PAYMENT_DOWNLOAD_PDF = "https://srvpay1.psisim.net/mopsimapp/payment/download-pdf";
